import { render, staticRenderFns } from "./ViewPayments.vue?vue&type=template&id=0452fdf8&scoped=true"
import script from "./ViewPayments.vue?vue&type=script&lang=js"
export * from "./ViewPayments.vue?vue&type=script&lang=js"
import style0 from "./ViewPayments.vue?vue&type=style&index=0&id=0452fdf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0452fdf8",
  null
  
)

export default component.exports